export const HIDE_POST_IMAGES_BEFORE_MS = Date.UTC(2022, 0, 1)

export function shouldHidePostImages (publishedAt: Date | string | null | undefined): boolean {
  if (publishedAt == null || publishedAt === '') {
    return false
  }

  const date = publishedAt instanceof Date ? publishedAt : new Date(publishedAt)
  if (Number.isNaN(date.getTime())) {
    return false
  }

  return date.getTime() < HIDE_POST_IMAGES_BEFORE_MS
}

export function stripImagesFromHtml (content: string): string {
  if (!content) {
    return content
  }

  return content
    .replace(/<figure\b[^>]*>(?:(?!<\/figure>)[\s\S])*<(?:picture|img)\b[\s\S]*?<\/figure>/gi, '')
    .replace(/<picture\b[^>]*>[\s\S]*?<\/picture>/gi, '')
    .replace(/<img\b[^>]*\/?>/gi, '')
}

export type PostImageFields = {
  /* eslint-disable camelcase */
  published_at?: string | null
  image?: unknown
  image_variants?: unknown
  /* eslint-enable camelcase */
  content?: string
  introduction?: string | null
}

export function hideImagesInPostData<T extends PostImageFields> (post: T): T {
  if (!shouldHidePostImages(post.published_at)) {
    return post
  }

  post.image = null
  post.image_variants = []

  if (typeof post.content === 'string') {
    post.content = stripImagesFromHtml(post.content)
  }

  if (typeof post.introduction === 'string') {
    post.introduction = stripImagesFromHtml(post.introduction)
  }

  return post
}

export function hideImagesInPostList (posts: Array<PostImageFields> | undefined | null): void {
  if (!Array.isArray(posts)) {
    return
  }

  posts.forEach((post) => {
    hideImagesInPostData(post)
  })
}
